import { keyframes } from "@emotion/react";

export const fadeIn = keyframes({
  from: { opacity: 0 },
  to: { opacity: 1 },
});

export const fadeInUp = keyframes({
  from: { opacity: 0, transform: "translateY(24px)" },
  to: { opacity: 1, transform: "translateY(0)" },
});

const styles = {
  bannerWrapperSx: {
    position: "relative",
    width: "100%",
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    minHeight: { xs: "100dvh", md: "100dvh" },
    pt: { xs: "72px", md: "80px" },
    pb: { xs: "40px", md: "180px" },
    px: { xs: 4, md: 3 },
  },

  logoAnimatedGridSx: (fadeInKf) => ({
    position: "relative",
    width: { xs: "240px", sm: "240px", md: "18%" },
    mb: 0,
    opacity: 0,
    animation: `${fadeInKf} 1.5s ease forwards`,
    animationDelay: "0.05s",
  }),

  logoImageSx: {
    width: "100%",
    zIndex: 2,
    backgroundColor: "black",
    px: { xs: 1, md: 1.5 },
  },

  dividerSx: {
    zIndex: 1,
    width: "100%",
    height: "1px",
    backgroundColor: "rgba(255,255,255,0.15)",
    position: "absolute",
    top: "50%",
    transform: "translateY(-50%)",
  },

  contentBlockSx: (fadeInUpKf) => ({
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    opacity: 0,
    animation: `${fadeInUpKf} 0.9s cubic-bezier(0.22, 1, 0.36, 1) forwards`,
    animationDelay: "0.3s",
  }),

  locationSx: {
    letterSpacing: "0.35em",
    color: "rgba(255,255,255,0.35)",
    fontSize: { xs: "0.62rem", md: "0.7rem" },
    mt: "-18px",
    mb: { xs: 2.5, md: 3 },
    zIndex: 2,
  },

  headlineSx: {
    fontSize: { xs: "clamp(2.5rem, 11vw, 3rem)", sm: "3.2rem", md: "4.5rem" },
    fontWeight: 700,
    letterSpacing: { xs: "0.01em", md: "0.04em" },
    lineHeight: 1,
    mb: { xs: 3, md: 3 },
    textAlign: "center",
  },

  subheadlineSx: {
    fontSize: { xs: "0.95rem", md: "1.05rem" },
    color: "rgba(255,255,255,0.45)",
    width: { xs: "90%", sm: "65%", md: "auto" },
    maxWidth: { xs: "90%", sm: "65%", md: "700px" },
    textAlign: "center",
    lineHeight: 1.9,
    whiteSpace: { md: "nowrap" },
  },

  decoratorRowSx: {
    display: "flex",
    alignItems: "center",
    gap: "10px",
    mt: { xs: 3.5, md: 4 },
    mb: { xs: 3.5, md: 4 },
    opacity: 0.25,
  },

  decoratorLineSx: { width: { xs: 40, md: 56 }, height: "1px", backgroundColor: "white" },

  decoratorDotSx: { width: 3, height: 3, borderRadius: "50%", backgroundColor: "white" },

  bookButtonSx: {
    px: { xs: 7, sm: 7 },
    py: { xs: 2, sm: 1.8 },
    fontSize: { xs: "0.85rem", sm: "0.88rem" },
  },

  scrollIndicatorSx: {
    position: "absolute",
    bottom: { xs: 28 },
    left: "50%",
    transform: "translateX(-50%)",
    display: { xs: "flex", md: "none" },
    flexDirection: "column",
    alignItems: "center",
    opacity: 0.28,
  },

  scrollLineSx: {
    width: "1px",
    height: "52px",
    background: "linear-gradient(to bottom, transparent, white)",
  },
};

export default styles;
